import { Stepper } from 'react-form-stepper'
import { useEffect, useState } from 'react'
import { StyledStepperContainer } from './GroundingStepper.styled'
import { useGroundingActionStore } from './store/useGroundingActionStore'
import shallow from 'zustand/shallow'
import { GroundingRenderStep } from './store/RenderStep'
import { useTheme } from 'styled-components'

interface IGroundingStepperProps {
  onClick: (code: number) => void
}

const CustomStepper = (props) => {
  const theme = useTheme()
  return (
    <StyledStepperContainer step4ButtonClicked={props.step4ButtonClicked}>
      <Stepper
        {...props}
        // nonLinear={true}
        onClick={(e) => {
          const current = e.target as HTMLButtonElement
          if (current.tagName != 'BUTTON') return
          props?.onStepClicked?.(+current.getAttribute('stepIndex'))
        }}
        connectorStateColors={true}
        connectorStyleConfig={{
          completedColor: theme.colors.stepperCompleteColor,
          activeColor: theme.colors.stepperCompleteColor,
          disabledColor: theme.colors.inputBorder
        }}
        styleConfig={{
          size: '20px',
          activeBgColor: theme.colors.InfinitiOnlyColor,
          completedBgColor: theme.colors.stepperCompleteColor,
          inactiveBgColor: theme.colors.inputBorder,
          activeTextColor: theme.colors.InfinitiOnlyColor,
          completedTextColor: theme.colors.stepperCompleteColor,
          inactiveTextColor: theme.colors.inputBorder
        }}
      />
    </StyledStepperContainer>
  )
}

export const GroundingStepper = (props: IGroundingStepperProps) => {
  const { activeStep, groundingStepInfor, isBack, isSubmit, setIsSubmit, setIsBack } = useGroundingActionStore(
    (state) => state,
    shallow
  )

  return (
    <CustomStepper
      steps={groundingStepInfor}
      onStepClicked={(stepIndex: number) => {
        if (stepIndex === activeStep) return
        if (
          activeStep === GroundingRenderStep.GRD_RESULT &&
          (stepIndex === GroundingRenderStep.GRD_OPTIONS ||
            stepIndex === GroundingRenderStep.GRD_TURN_IN ||
            stepIndex === GroundingRenderStep.GRD_ENTER_VIN)
        ) {
          return
        }
        props.onClick(stepIndex)
      }}
    />
  )
}
